import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataSouhait } from '../../data/DataSouhait';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxMotifAcquisition } from '../ComboBox/ComboBoxMotifAcquisition';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation';
import { ComboBoxOrigineCommerciale } from '../ComboBox/ComboBoxOrigineCommerciale';
import { ComboBoxSuiviCommercial } from '../ComboBox/ComboBoxSuiviCommercial';
import { ComboBoxVilleAdministrative } from '../ComboBox/ComboBoxVilleAdministrative';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUITextField } from '../EUI/EUITextField';
import { FicheContact } from '../Fiche/FicheContact/FicheContact';
import FicheSouhait from '../Fiche/FicheSouhait';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './DetailsListSouhait.css';

/*
***************************************************************
 PROPS:

    //*********************************************************
    //Appel depuis contact
    //pas de bouton d'édition du contact
    //CSS spécifique
    //idContact chargé dans la fiche contact et la fiche souhait est égale à la props passée en paramètre

    
    appelDepuisContact
    idContact
    typeDeSouhait => Appartement ou Maison individuelle ou les 2
    //*********************************************************


    //****************************************************************************************************************************************************
    //Appel depuis la réservation
        //paramètres en entrée : 
        //  liste d'IdContact et d'IdSouhait => chargement du tableau avec ces IDs
        //  Sélection d'une ligne et faire un retour de l'IdContact et l'IdSouhait sélectionnés
        //pas de zone de commandBar
        //CSS spécifique
        //Pas d'affichage des liens vers les souhaits, dénonciations et historique

    idLotCommercial => permet de charger la nature du lotCommercial dans le souhait
    idOperation => permet de charger la nature du lotCommercial dans le souhait

    //*********************************************************
    //en mode création de réservation
    appelDepuisReservation
    selectionIdContactIdSouhait => objet json sous la forme =>let objIdContactIdSouhait = [{ "idContact": 34, "idSouhait": 2 }, { "idContact": 3174, "idSouhait": 2 }]
    //*********************************************************

    //en mode modification de réservation
    idReservation => mode modification lors d'appel depuis une réseravtion existante, permet de récupérer le souhait déclaré sur la réservation sinon par défaut on ne récupère pas les souhaits liés à des réservations
    //*********************************************************

    //mode sélection de souhait
    onSelectionSouhait => méthode utilisée par le parent pour récupérer l'IdContact et l'IdSouhait du souhait sélectionné
    modeSelectionDeSouhait => SelectionMode.none, SelectionMode.single, SelectionMode.multiple

    //*********************************************************
    //Appel depuis tableau de bord
    //*********************************************************
    FiltreRDV

    //**************************
    //Appel depuis FicheContact (appelé depuis FicheReservation)
    //**************************
    //suppressionSouhaitPossible --> Permet de ne pas supprimer de souhait
    //modificationSouhaitPossible --> Permet de ne pas modifier de souhait
    //****************************************************************************************************************************************************
*/

var objetState = {
    items: [],
    idContact: 0,
    idSouhait: 0,

    enCoursDeTraitement: false,
    onAffichePanelContact: false,
    onAffichePanelSouhait: false,
    onAffichePanelFiltre: false,
    onAfficheDialogSuppressionSouhait: false,

    selectionIdContactIdSouhait: [],

    peutCreerDesSouhaits: false,

    pageIndex: 1,
    facteurNbreEnregistrement: 500,
    tri: "",

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    hideMessageBarFiltres: true,
    warningMessage: '',
    errorMessage: '',
    messageMessageBarFiltres: '',

    recherche: '',

    filtreNomContact: '',
    filtreIdSociete: 0,
    filtreLoginCompte: '',
    filtreRechercheMotifAcquisition: '',
    filtreIdOperation: 0,
    filtreIdVilleAdministrative: '0',
    filtreRechercheOrigineCommerciale: '',
    filtreSuiviCommercial: '',
    filtreDateDernierSuiviCommercialMin: null,
    filtreDateDernierSuiviCommercialMax: null,
    filtreProchaineAlarmeMin: null,
    filtreProchaineAlarmeMax: null,

    //AF - Utilisé uniquement pour stocker les valeurs provenant du TDB
    filtreNonReserves: false,
    filtreRDV1: '',
    filtreRDV2: '',
    filtreRDV3: '',
    filtreMinJourDernierSuiviCommercialOuRdv: '',
    filtreMaxJourDernierSuiviCommercialOuRdv: '',
};


export class DetailsListSouhait extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListSouhaitWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListSouhaitWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _selection;

    _creationContent() {
        const { items } = this.state;

        let Selection = (this.props.modeSelectionDeSouhait !== undefined ? this.props.modeSelectionDeSouhait : SelectionMode.multiple);

        return (
            <DetailsList
                setKey="items"
                items={items}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                selectionMode={Selection}
                columns={this.columns}
                selection={this._selection}
                selectionPreservedOnEmptyClick={true}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onRenderItemColumn={this._onRenderItemColumn}
            />
        );
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({ selectionDetails: this._selection.getSelection() });
                this._getSelectionDetails();
            }
        });

        this.state = objetState;

        //#region chargement des columns
        let columnsTemp = [];
        columnsTemp.push({
            key: 'clef',
            name: 'clef',
            ariaLabel: '',
            fieldName: 'clef',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.idReservation != null && item.idReservation != undefined) {
                    return <Icon iconName="Permissions" className="reservationPosee" />;
                }
                else {
                    return null;
                }
            }
        });
        columnsTemp.push({
            key: 'NomContact',
            name: 'Projet',
            fieldName: 'NomContact',
            minWidth: 200,
            maxWidth: 350,
            isResizable: true,
            onRender: (item) => {
                let nomContact = item.nomContact;
                return <span title={nomContact}>{'Projet - ' + nomContact}</span>;
            }
        });
        columnsTemp.push({
            key: 'SuiviCommercial',
            name: 'Suivi commercial',
            ariaLabel: 'Suivi commercial',
            fieldName: 'SuiviCommercial',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let existeReservation = (item.idReservation !== undefined && item.idReservation !== null);
                let suiviCommercial = (existeReservation ? 'Client' : item.suiviCommercial);
                return <span title={suiviCommercial}>{suiviCommercial}</span>;
            }
        });
        columnsTemp.push({
            key: 'DernierRDV',
            name: 'Dernier RDV',
            fieldName: 'DernierRDV',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let dernierRDV = item.dernierRDV;
                if (dernierRDV != null) {
                    dernierRDV = Scriba.date().stringDateFormatCourt(item.dernierRDV);
                } else {
                    dernierRDV = "A planifier";
                }

                return <span className='ms-hiddenMdDown' title={dernierRDV}>{dernierRDV}</span>;
            }
        });
        columnsTemp.push({
            key: 'NomCommercial',
            name: 'Opération',
            fieldName: 'NomCommercial',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                const nomCommercial = item.rechercheNomCommercial || item.nomCommercial;
                return <span title={nomCommercial}>{nomCommercial}</span>;
            }
        });
        columnsTemp.push({
            key: 'ZoneGeographique',
            name: 'Zone géographique',
            ariaLabel: 'Zone géographique',
            fieldName: 'ZoneGeographique',
            minWidth: 120,
            maxWidth: 140,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let zoneGeographique = item.zoneGeographique;
                return <span title={zoneGeographique}>{zoneGeographique}</span>;
            }
        });
        columnsTemp.push({
            key: 'CreerLe',
            name: 'Date souhait',
            fieldName: 'CreerLe',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let creerLe = Scriba.date().stringDateFormatCourt(item.creerLe);
                return <span title={creerLe}>{creerLe}</span>;
            }
        });
        columnsTemp.push({
            key: 'proprietaireSocieteCompte',
            name: 'Propriétaire',
            fieldName: 'proprietaireSocieteCompte',
            minWidth: 120,
            maxWidth: 160,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let proprietaireSocieteCompte = item.proprietaireSocieteCompte;
                return <span title={proprietaireSocieteCompte}>{proprietaireSocieteCompte}</span>;
            }
        });
        columnsTemp.push({
            key: 'rechercheMotifAcquisition',
            name: 'Motif Acq.',
            fieldName: 'rechercheMotifAcquisition',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let rechercheMotifAcquisition = item.rechercheMotifAcquisition;
                return <span title={rechercheMotifAcquisition}>{rechercheMotifAcquisition}</span>;
            }
        });
        columnsTemp.push({
            key: 'ModifierLe',
            name: 'Dernière modification',
            ariaLabel: 'Dernière modification',
            fieldName: 'ModifierLe',
            minWidth: 80,
            maxWidth: 140,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let modifierLe = Scriba.date().stringDateHeureFormatCourt(item.souhaitModifierLe);
                return <span title={modifierLe}>{modifierLe}</span>;
            }
        });
        columnsTemp.push({
            key: 'ProchaineAlarme',
            name: 'Prochaine alarme active',
            ariaLabel: 'Prochaine alarme active',
            fieldName: 'ProchaineAlarme',
            minWidth: 80,
            maxWidth: 140,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let prochaineAlarme = Scriba.date().stringDateHeureFormatCourt(item.prochaineAlarme);
                return <span title={prochaineAlarme}>{prochaineAlarme}</span>;
            }
        });
        if (!this.props.appelDepuisContact) {
            columnsTemp.push({
                key: 'EditionContact',
                name: 'EditionContact',
                ariaLabel: 'Modifier le contact',
                fieldName: 'EditionContact',
                minWidth: 20,
                maxWidth: 20,
                isIconOnly: true,
                isSorted: false,
                onRender: (item) => {
                    if (item.peutEditerContact) {
                        return <IconButton
                            iconProps={{ iconName: 'EditContact' }}
                            title="Modifier le contact"
                            ariaLabel="Edition"
                            onClick={() => this._onAffichagePanelContact(item.idContact)}
                        />;
                    }
                    else {
                        return null;
                    }
                }
            });
        }
        columnsTemp.push({
            key: 'EditionSouhait',
            name: 'EditionSouhait',
            ariaLabel: 'Modifier le souhait',
            fieldName: 'EditionSouhait',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                //let modificationSouhaitPossible = (this.props.modificationSouhaitPossible !== undefined ? this.props.modificationSouhaitPossible : true);

                let modificationSouhaitPossible = true;

                //Si on arrive de la prospection et si souhait lié à une réservation => on cache la bouton Modification
                if ((this.props.appelDepuisReservation == undefined || !this.props.appelDepuisReservation) & (item.idReservation != null && item.idReservation != undefined)) {
                    // MG - Pour modifier le souhait lié a une resa
                    modificationSouhaitPossible = true;
                }//Si on arrive de la réservation et si la réservation est validéeCG => on cache la bouton Modification
                else if ((this.props.appelDepuisReservation != undefined && this.props.appelDepuisReservation) & (item.validationCG != null && item.validationCG != undefined && item.validationCG)) {
                    modificationSouhaitPossible = false;
                }

                if (item.peutModifier && modificationSouhaitPossible) {
                    return <IconButton
                        iconProps={{ iconName: 'Edit' }}
                        title="Modifier le souhait"
                        ariaLabel="Edition"
                        onClick={() => this._onAffichagePanelSouhait(item.idContact, item.idSouhait)}
                    />;
                }
                else {
                    return null;
                }
            }
        });
        columnsTemp.push({
            key: 'delete',
            name: 'Delete',
            ariaLabel: 'Supprimer le souhait',
            fieldName: 'delete',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                //let suppressionSouhaitPossible = (this.props.suppressionSouhaitPossible !== undefined ? this.props.suppressionSouhaitPossible : true);

                let suppressionSouhaitPossible = true;

                //dès l'instant où il y a une réservation liée au souhait on cache le bouton suppression
                if (item.idReservation != null && item.idReservation != undefined) {
                    suppressionSouhaitPossible = false;
                }

                if (item.peutSupprimer && suppressionSouhaitPossible) {
                    return <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        title="Supprimer le souhait"
                        ariaLabel="Suppression"
                        onClick={() => this._onAffichageDialogSuppressionSouhait(item.idContact, item.idSouhait)}
                    />;
                }
                else {
                    return null;
                }
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }

    _getItems = () => {
        let tableauBoutons = [
            {
                key: 'search',
                onRender: () => <SearchBox
                    placeholder="Recherche rapide"
                    className="searchBox"
                    onSearch={value => this._onSearchBox(value)}
                    onClear={(e) => this._onSearchBox('')}
                //onBlur={(e) => this._onBlurSearchBox(e.target.value)}
                />
            },
        ];

        if (this.state.peutCreerDesSouhaits) {
            if (this._selection.getSelectedCount() > 0 | (this.props.idContact > 0)) {

                let idContact = 0;

                if (this.props.idContact > 0) {
                    idContact = this.props.idContact;
                }
                else {
                    this._selection.getSelection().map(function (souhait) {
                        idContact = souhait.idContact;
                    });
                }

                let boutonNouveauSouhait = {
                    key: 'nouveauSouhait',
                    name: 'Nouveau souhait',
                    iconProps: {
                        iconName: 'Add'
                    },
                    onClick: (() => this._onAffichagePanelSouhait(idContact, null))
                }

                tableauBoutons.push(boutonNouveauSouhait);
            }
        }

        return tableauBoutons;
    }

    _getFarItems = () => {
        //if (this.props.appelDepuisReservation) {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
        //}
        //else {
        //    return null;
        //}
    }

    _onSuppressionSouhait = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression du souhait en cours'
        });

        var onSuppressionSouhait = DataSouhait._onSuppressionSouhait(this.state.idContact, this.state.idSouhait);

        onSuppressionSouhait
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    // MG - 23/02/2022 - retirer le souhait supprimé du state pour recharger
                    this.setState(prevState =>
                    ({
                        items: prevState.items.filter(item => item.idContact !== this.state.idContact && item.idSouhait !== this.state.idSouhait),
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarError: true,
                        errorMessage: '',

                        onAfficheDialogSuppressionSouhait: false,

                        idContact: 0,
                        idSouhait: 0

                    }), this._chargementDonnees);
                }
                else {
                    let stateTemp = {};
                    stateTemp.idContact = 0;
                    stateTemp.idSouhait = 0;
                    stateTemp.onAfficheDialogSuppressionSouhait = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des souhaits en cours'
        });

        //si this.props.selectionIdContactIdSouhait est renseigné => on souhaite récupérer les souhaits définis par ces clefs
        //si idContact est renseigné => on souhaite récupérer les souhaits du contact
        //si non on récupère tous les souhaits


        //#region AF - Filtres utilisés pour les affichages du tableau de bord
        //On prend la valeur du localstorage si on vient du TDB sinon on prend le state
        //-----------------------------------------------------
        let filtreNonReservesTrav = (localStorage.getItem("filtreNonReserves") !== null ? (localStorage.getItem("filtreNonReserves") === "true" ? true : false) : this.state.filtreNonReserves);

        //Souhaits par RDV
        let filtreRDV1Trav = (localStorage.getItem("filtreRDV1") !== null ? localStorage.getItem("filtreRDV1") : this.state.filtreRDV1);
        let filtreRDV2Trav = (localStorage.getItem("filtreRDV2") !== null ? localStorage.getItem("filtreRDV2") : this.state.filtreRDV2);
        let filtreRDV3Trav = (localStorage.getItem("filtreRDV3") !== null ? localStorage.getItem("filtreRDV3") : this.state.filtreRDV3);

        //Souhaits par suivi commercial
        let filtreSuiviCommercialTrav = (localStorage.getItem("filtreSuiviCommercial") !== null ? localStorage.getItem("filtreSuiviCommercial") : this.state.filtreSuiviCommercial);

        //Souhaits durée entre aujourd'hui et derniere date de suivi commercial ou rdv
        let filtreMinJourDernierSuiviCommercialOuRdvTrav = (localStorage.getItem("filtreMinJourDernierSuiviCommercialOuRdv") !== null ? localStorage.getItem("filtreMinJourDernierSuiviCommercialOuRdv") : this.state.filtreMinJourDernierSuiviCommercialOuRdv);
        let filtreMaxJourDernierSuiviCommercialOuRdvTrav = (localStorage.getItem("filtreMaxJourDernierSuiviCommercialOuRdv") !== null ? localStorage.getItem("filtreMaxJourDernierSuiviCommercialOuRdv") : this.state.filtreMaxJourDernierSuiviCommercialOuRdv);
        //#endregion

        let chargementDesSouhaits = DataSouhait._chargementDesSouhaits(this.props.idContact, this.state.facteurNbreEnregistrement, this.state.pageIndex, this.state.recherche, this.state.tri,
            this.props.selectionIdContactIdSouhait, this.props.appelDepuisReservation, this.props.idOperation, this.props.idReservation, this.state.filtreNomContact, this.state.filtreIdSociete, this.state.filtreLoginCompte,
            this.state.filtreRechercheMotifAcquisition, this.state.filtreIdOperation, this.state.filtreIdVilleAdministrative, this.state.filtreRechercheOrigineCommerciale,
            filtreSuiviCommercialTrav, this.state.filtreDateDernierSuiviCommercialMin, this.state.filtreDateDernierSuiviCommercialMax,
            this.state.filtreProchaineAlarmeMin, this.state.filtreProchaineAlarmeMax, filtreNonReservesTrav, filtreRDV1Trav, filtreRDV2Trav, filtreRDV3Trav,
            filtreMinJourDernierSuiviCommercialOuRdvTrav, filtreMaxJourDernierSuiviCommercialOuRdvTrav);

        chargementDesSouhaits
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    let new_Items = [];
                    let retourData = responseFetch.reponseAPIobjet;
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (retourData[0] !== null ? retourData[0] : []);

                    if (this.state.pageIndex === 1) {
                        new_Items = listeItem;
                    }
                    else {
                        new_Items = this.state.items;
                        new_Items = new_Items.concat(listeItem);
                    }

                    let onNAppellePasDepuisLaReservation = (this.props.appelDepuisReservation == undefined || !this.props.appelDepuisReservation);
                    let onAppelleDepuisLaReservationEnModeCreation = (this.props.appelDepuisReservation != undefined && this.props.appelDepuisReservation != null) && (this.props.idReservation == undefined && this.props.idReservation == null);
                    let aLeDroitDeCreerUnSouhait = retourData[1];
                    let peutCreerDesSouhaits = (onNAppellePasDepuisLaReservation && aLeDroitDeCreerUnSouhait) || (onAppelleDepuisLaReservationEnModeCreation && aLeDroitDeCreerUnSouhait);

                    this.setState({
                        items: new_Items,

                        peutCreerDesSouhaits: peutCreerDesSouhaits,

                        //AF - TDB - On met à jour les valeurs 
                        filtreNonReserves: filtreNonReservesTrav,
                        filtreRDV1: filtreRDV1Trav,
                        filtreRDV2: filtreRDV2Trav,
                        filtreRDV3: filtreRDV3Trav,
                        filtreSuiviCommercial: filtreSuiviCommercialTrav,
                        filtreMinJourDernierSuiviCommercialOuRdv: filtreMinJourDernierSuiviCommercialOuRdvTrav,
                        filtreMaxJourDernierSuiviCommercialOuRdv: filtreMaxJourDernierSuiviCommercialOuRdvTrav,
                        filtreProchaineAlarmeMin: this.state.filtreProchaineAlarmeMin,
                        filtreProchaineAlarmeMax: this.state.filtreProchaineAlarmeMax,

                        enCoursDeTraitement: false,
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage,
                        hideMessageBarFiltres: (responseFetch.messageInfo === "" || responseFetch.messageInfo === null),
                        messageMessageBarFiltres: responseFetch.messageInfo
                    });

                    //On ne réinitialise les filtres de tableau de bord que lorsque la popup d'alarme est fermée
                    if (!this.state.onAfficheModalAlarmes) {
                        this._reinitFiltresTableauDeBord();
                    }
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.peutCreerDesSouhaits = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _reinitFiltresTableauDeBord() {
        localStorage.removeItem('filtreNonReserves');
        localStorage.removeItem('filtreRDV1');
        localStorage.removeItem('filtreRDV2');
        localStorage.removeItem('filtreRDV3');
        localStorage.removeItem('filtreSuiviCommercial');
        localStorage.removeItem('filtreMinJourDernierSuiviCommercialOuRdv');
        localStorage.removeItem('filtreMaxJourDernierSuiviCommercialOuRdv');
    }

    _getSelectionDetails() {
        if (this.props.modeSelectionDeSouhait !== undefined & this.props.modeSelectionDeSouhait !== SelectionMode.none) {
            if (this._selection.getSelectedCount() > 0) {
                this.setState({
                    selectionIdContactIdSouhait: []
                });

                //*********************************************************************************************************
                //ne voulant pas tout modifié dans les formulaires appelants car devant résoudre rapidement ce bug, j'ai réimplémenté la même structure de l'objet qu'on avait auparavant
                //néanmoins, je serai souhaitable dès qu'on a le temps de modifier ce code afin de juste passer objet.idContact et objet.idSouhait
                let objet = { _items: [] };
                const _itemsSel = {
                    idContact: null,
                    idSouhait: null
                };
                _itemsSel.idContact = this._selection.getSelection()[0].idContact;
                _itemsSel.idSouhait = this._selection.getSelection()[0].idSouhait;
                _itemsSel.rechercheMotifAcquisition = this._selection.getSelection()[0].rechercheMotifAcquisition;
                _itemsSel.rechercheOrigineCommerciale = this._selection.getSelection()[0].rechercheOrigineCommerciale;

                objet._items[0] = _itemsSel;
                //*********************************************************************************************************

                this.props.onSelectionSouhait(objet);//this._selection);//=> sous cette forme this._selection.getSelection()[0].idSouhait
            }
            else {
                this.props.onSelectionSouhait(null);

                this.setState({
                    selectionIdContactIdSouhait: []
                });
            }
        }
    }

    _onAffichagePanelContact = (idContact) => {
        this.setState({
            onAffichePanelContact: true,
            idContact: idContact
        });
    }

    _onAffichagePanelSouhait = (idContact, idSouhait) => {
        this.setState({
            onAffichePanelSouhait: true,
            idContact: idContact,
            idSouhait: idSouhait
        });
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true });
    };

    _onAffichageDialogSuppressionSouhait = (idContact, idSouhait) => {
        this.setState({
            onAfficheDialogSuppressionSouhait: true,

            idContact: idContact,
            idSouhait: idSouhait
        });
    }

    _onCachePanelContact = () => {
        if (this.state.onAffichePanelContact) {
            this.setState({
                onAffichePanelContact: false,
                idContact: 0
            });
        }
    };
    _onCachePanelContactEtRechargementDesDonnees = () => {
        if (this.state.onAffichePanelContact) {
            this.setState({
                onAffichePanelContact: false,
                idContact: 0
            });
            this._chargementDonnees();
        }
    };

    _onCachePanelSouhait = (rechargementDesDonnees) => () => {
        if (this.state.onAffichePanelSouhait) {
            this.setState({
                onAffichePanelSouhait: false,
                idContact: 0,
                idSouhait: 0
            });
            if (rechargementDesDonnees) this._chargementDonnees();
        }
    };

    _onEnregistrementFicheSouhait = () => {
        this._selection.setAllSelected(false); // RAZ de la sélection
        if (this.props.onSelectionSouhait) this.props.onSelectionSouhait(null); // MAJ éventuelle du parent
        this._onCachePanelSouhait(true)();
    };

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    };

    _onCacheDialogSuppressionSouhait = () => {
        this.setState({
            onAfficheDialogSuppressionSouhait: false,

            idContact: 0,
            idSouhait: 0
        });
    }

    _onSearchBox = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            filtreNomContact: '',
            filtreIdSociete: 0,
            filtreLoginCompte: '',
            filtreRechercheMotifAcquisition: '',
            filtreIdOperation: 0,
            filtreIdVilleAdministrative: '0',
            filtreRechercheOrigineCommerciale: '',
            filtreSuiviCommercial: '',
            filtreDateDernierSuiviCommercialMin: null,
            filtreDateDernierSuiviCommercialMax: null,
            filtreProchaineAlarmeMin: null,
            filtreProchaineAlarmeMax: null,

            pageIndex: 1,
            facteurNbreEnregistrement: 500
        });
    }

    _onSelectDate(value, champ) {
        var valeurDate = Scriba.date().getChaineISOFromDate(value, true);
        this.setState({ [champ]: valeurDate });
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    };

    _incrementeNbreEnregistrementEtChargementDonnees() {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    //*************************************************************
    //    //ne marche pas
    //    //if(this.props.onRecharge === true)
    //    //    this._chargementDonnees();
    //    //*************************************************************
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }

    //    let propsSelectionIdContactIdSouhaitRenseignee = Immocom.getSiPropsRenseignee(this.props.selectionIdContactIdSouhait);
    //    let onRecharge = (
    //        propsSelectionIdContactIdSouhaitRenseignee &&
    //        this.props.selectionIdContactIdSouhait !== this.state.selectionIdContactIdSouhait);

    //    if (onRecharge) {// && this.props.onPeutChargerLeComposant) {
    //        this.setState({
    //            pageIndex: 1,
    //            selectionIdContactIdSouhait: this.props.selectionIdContactIdSouhait
    //        }, this._chargementDonnees);
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);

        let propsSelectionIdContactIdSouhaitRenseignee = Immocom.getSiPropsRenseignee(this.props.selectionIdContactIdSouhait);
        let onRecharge = (
            propsSelectionIdContactIdSouhaitRenseignee &&
            this.props.selectionIdContactIdSouhait !== this.state.selectionIdContactIdSouhait);

        if (onRecharge) {// && this.props.onPeutChargerLeComposant) {
            this.setState({
                pageIndex: 1,
                selectionIdContactIdSouhait: this.props.selectionIdContactIdSouhait
            }, this._chargementDonnees);
        }
    };

    render = () => {

        const content = this._creationContent();
        const idContact = (this.props.appelDepuisContact ? this.props.idContact : this.state.idContact);

        //**************************************************************************************************************
        //si on arrive de la réservation on n'affiche pas les liens vers les souhaits, dénonciations et historique
        //let ficheContactPasDAccesAuxSouhaits = this.props.appelDepuisReservation;
        //let ficheContactPasDAccesAuxSouhaitsMaisonIndividuelle = this.props.appelDepuisReservation;
        //let ficheContactPasDAccesAuxDenonciations = this.props.appelDepuisReservation;
        //let ficheContactPasDAccesAHistorique = this.props.appelDepuisReservation;
        //**************************************************************************************************************

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                {this.props.appelDepuisReservation || this.props.appelDepuisContact ? content :
                    <div className="position-relative h-100">
                        <ScrollablePane
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            onScroll={this._onScroll}
                        >
                            {content}
                        </ScrollablePane>
                    </div>
                }
            </Stack>

            <EUIPanel
                headerText="Filtres"
                isOpen={this.state.onAffichePanelFiltre}
                onDismiss={this._onCachePanelFiltre}
                onResetFilters={this._reinitFiltre}
                onValidate={this._onFiltreTableau}
            >

                <EUITextField
                    label="Contact"
                    maxLength={MaxLengths.contact.nom}
                    onChange={(event, newValue) => this.setState({ filtreNomContact: newValue })}
                    placeholder="Saisir le nom"
                    value={this.state.filtreNomContact}
                />

                <ComboBoxMotifAcquisition
                    onChange={(event, option, index, value, item) => this.setState({ filtreRechercheMotifAcquisition: option.key })}
                    selectedKey={this.state.filtreRechercheMotifAcquisition}
                />

                <ComboBoxOperation
                    idAgenceRequired={false}
                    onChange={(event, option, index, value, item) => this.setState({ filtreIdOperation: option.key })}
                    perimetre="eiffage"
                    selectedKey={this.state.filtreIdOperation}
                />

                <ComboBoxVilleAdministrative
                    filtreSurMonPerimetre
                    idDepartementAdministratifRequired={false}
                    onChange={(event, option, index, value, item) => this.setState({ filtreIdVilleAdministrative: option.key })}
                    selectedKey={this.state.filtreIdVilleAdministrative}
                />

                <ComboBoxOrigineCommerciale
                    onChange={(event, option, index, value, item) => this.setState({ filtreRechercheOrigineCommerciale: option.key })}
                    selectedKey={this.state.filtreRechercheOrigineCommerciale}
                />

                <ComboBoxSuiviCommercial
                    onChange={(event, option) => this.setState({ filtreSuiviCommercial: option.key })}
                    selectedKey={this.state.filtreSuiviCommercial}
                />

                <EUIDatePicker
                    label="Date de dernier suivi commercial du"
                    onSelectDate={date => this._onSelectDate(date, 'filtreDateDernierSuiviCommercialMin')}
                    value={this.state.filtreDateDernierSuiviCommercialMin}
                />

                <EUIDatePicker
                    label="Au"
                    onSelectDate={date => this._onSelectDate(date, 'filtreDateDernierSuiviCommercialMax')}
                    value={this.state.filtreDateDernierSuiviCommercialMax}
                />

                <EUIDatePicker
                    label="Date prochaine alarme active du"
                    onSelectDate={date => this._onSelectDate(date, 'filtreProchaineAlarmeMin')}
                    value={this.state.filtreProchaineAlarmeMin}
                />

                <EUIDatePicker
                    label="Au"
                    onSelectDate={date => this._onSelectDate(date, 'filtreProchaineAlarmeMax')}
                    value={this.state.filtreProchaineAlarmeMax}
                />

            </EUIPanel>

            <FicheContact
                isOpen={this.state.onAffichePanelContact}
                idContact={idContact}
                onAnnuleFiche={() => this._onCachePanelContactEtRechargementDesDonnees()}
                onEnregistrementFiche={() => this._onCachePanelContactEtRechargementDesDonnees()}
            //pasDAccesAuxSouhaits={ficheContactPasDAccesAuxSouhaits}
            //pasDAccesAuxSouhaitsMaisonIndividuelle={ficheContactPasDAccesAuxSouhaitsMaisonIndividuelle}
            //pasDAccesAuxDenonciations={ficheContactPasDAccesAuxDenonciations}
            //pasDAccesAHistorique={ficheContactPasDAccesAHistorique}

            //onPeutChargerLeComposant={this.state.onAffichePanelContact}
            />

            <FicheSouhait
                idContact={idContact}
                idLotCommercial={this.props.idLotCommercial}
                idOperation={this.props.idOperation}
                idSouhait={this.state.idSouhait}
                isOpen={this.state.onAffichePanelSouhait}
                onDismiss={this._onCachePanelSouhait(false)}
                onSave={this._onEnregistrementFicheSouhait}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogSuppressionSouhait}
                onDismiss={this._onCacheDialogSuppressionSouhait}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression du souhait',
                    subText: 'Attention, vous êtes en train de supprimer un souhait, souhaitez-vous continuer?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={this._onSuppressionSouhait} text="Supprimer" />
                    <DefaultButton onClick={this._onCacheDialogSuppressionSouhait} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    }
}